/*!
 * @license
 * Copyright © 2005-2024 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { RatingEntry } from '../model/ratingEntry';
import { RatingPaging } from '../model/ratingPaging';
import { BaseApi } from './base.api';
import { throwIfNotDefined } from '../../../assert';
import { buildCollectionParam } from '../../../alfrescoApiClient';
export class RatingsApi extends BaseApi {
    createRating(nodeId, ratingBodyCreate, opts) {
        throwIfNotDefined(nodeId, 'nodeId');
        throwIfNotDefined(ratingBodyCreate, 'ratingBodyCreate');
        const pathParams = {
            nodeId
        };
        const queryParams = {
            fields: buildCollectionParam(opts === null || opts === void 0 ? void 0 : opts.fields, 'csv')
        };
        return this.post({
            path: '/nodes/{nodeId}/ratings',
            pathParams,
            queryParams,
            bodyParam: ratingBodyCreate,
            returnType: RatingEntry
        });
    }
    deleteRating(nodeId, ratingId) {
        throwIfNotDefined(nodeId, 'nodeId');
        throwIfNotDefined(ratingId, 'ratingId');
        const pathParams = {
            nodeId,
            ratingId
        };
        return this.delete({
            path: '/nodes/{nodeId}/ratings/{ratingId}',
            pathParams
        });
    }
    getRating(nodeId, ratingId, opts) {
        throwIfNotDefined(nodeId, 'nodeId');
        throwIfNotDefined(ratingId, 'ratingId');
        const pathParams = {
            nodeId,
            ratingId
        };
        const queryParams = {
            fields: buildCollectionParam(opts === null || opts === void 0 ? void 0 : opts.fields, 'csv')
        };
        return this.get({
            path: '/nodes/{nodeId}/ratings/{ratingId}',
            pathParams,
            queryParams,
            returnType: RatingEntry
        });
    }
    listRatings(nodeId, opts) {
        throwIfNotDefined(nodeId, 'nodeId');
        const pathParams = {
            nodeId
        };
        const queryParams = {
            skipCount: opts === null || opts === void 0 ? void 0 : opts.skipCount,
            maxItems: opts === null || opts === void 0 ? void 0 : opts.maxItems,
            fields: buildCollectionParam(opts === null || opts === void 0 ? void 0 : opts.fields, 'csv')
        };
        return this.get({
            path: '/nodes/{nodeId}/ratings',
            pathParams,
            queryParams,
            returnType: RatingPaging
        });
    }
}
